import ReducerIndex from 'qwc2/reducers/index';
import dirtyReducer from '../reducers/dirty';
import {setCurrentTaskBlocked} from 'qwc2/actions/task';
import LocaleUtils from 'qwc2/utils/LocaleUtils';

ReducerIndex.register("dirty", dirtyReducer);

export const SET_DIRTY = 'SET_DIRTY';

export function setDirty(windowId, dirty) {
    return (dispatch, getState) => {
        dispatch({
            type: SET_DIRTY,
            windowId,
            dirty
        });
        const anyDirty = Object.values(getState().dirty).some(Boolean);
        dispatch(setCurrentTaskBlocked(anyDirty, anyDirty ? LocaleUtils.tr("featuredetails.unsavedchanges") : null));
    };
}
